document.addEventListener("DOMContentLoaded", () => {
  window.Shopify.loadFeatures(
    [
      {
        name: "consent-tracking-api",
        version: "0.1"
      }
    ],
    (e) => {
      if (e)
        throw e;
      d();
    }
  );
});
const i = () => {
  const e = document.querySelector(
    '[modal-id="modal-tangiblee"]'
  );
  e && e.remove();
  const n = document.querySelector("#modal-tangiblee");
  n && n.remove();
}, d = () => {
  const e = window.Shopify.customerPrivacy.currentVisitorConsent();
  if (e.marketing === "" && e.analytics === "") {
    i();
    return;
  }
  if (!(window.Shopify.customerPrivacy.marketingAllowed() && window.Shopify.customerPrivacy.analyticsProcessingAllowed())) {
    i();
    return;
  }
  const t = document.querySelector(
    '[modal-id="modal-tangiblee"] button'
  );
  if (!t) return;
  t.removeAttribute("hidden");
  const o = document.querySelector("#modal-tangiblee");
  if (o) {
    if (o.hasAttribute("open")) {
      a();
      return;
    }
    t.addEventListener("click", () => {
      a();
    });
  }
}, a = () => {
  const e = setInterval(() => {
    window.tangibleeScriptLoaded && (clearInterval(e), n());
  }, 500), n = () => {
    tangiblee("activeATC", '.btn[name="add"]'), tangiblee("onModalClosed", function() {
      document.querySelector("#modal-tangiblee").closeModal();
    });
  };
};
